// Cookie操作工具函数
const cookieUtils = {
  /**
   * 设置Cookie
   * @param {string} name - Cookie名称
   * @param {string} value - Cookie值
   * @param {number} days - 过期天数，可选
   * @param {string} path - 路径，默认为'/'
   * @param {string} domain - 域名，可选
   * @param {boolean} secure - 是否仅HTTPS传输，默认false
   */
  setCookie: function(name, value, days, path = '/', domain, secure = false) {
    let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    
    // 处理过期时间
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      cookieStr += `; expires=${date.toUTCString()}`;
    }
    
    // 处理路径
    cookieStr += `; path=${path}`;
    
    // 处理域名
    if (domain) {
      cookieStr += `; domain=${domain}`;
    }
    
    // 处理安全标志
    if (secure) {
      cookieStr += '; secure';
    }
    
    document.cookie = cookieStr;
  },
  
  /**
   * 获取Cookie值
   * @param {string} name - 要获取的Cookie名称
   * @returns {string|null} - 返回Cookie值，不存在则返回null
   */
  getCookie: function(name) {
    const cookies = document.cookie.split(';');
    const targetName = encodeURIComponent(name);
    
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      // 检查是否是目标Cookie
      if (cookie.indexOf(`${targetName}=`) === 0) {
        return decodeURIComponent(cookie.substring(targetName.length + 1));
      }
    }
    
    // 未找到对应Cookie
    return null;
  },
  
  /**
   * 删除Cookie
   * @param {string} name - 要删除的Cookie名称
   * @param {string} path - 路径，默认为'/'
   * @param {string} domain - 域名，可选
   */
  deleteCookie: function(name, path = '/', domain) {
    // 通过设置过期时间为过去来删除Cookie
    this.setCookie(name, '', -1, path, domain);
  }
};

export default cookieUtils;